import { createRouter, createWebHashHistory } from "vue-router";
import Home from "@/views/Home.vue";
// import DetailConnect from "@/views/DetailConnect.vue";
import DetailTelerehap from "@/views/DetailTelerehap";
import DetailBium from "@/views/DetailBium";
import DetailTasteOfBook from "@/views/DetailTasteOfBook";
import DetailMilkUi from "@/views/DetailMilkUi";
import DetailAlice from "@/views/DetailAlice";
import DetailMgtable from "@/views/DetailMgtable";
import DetailMooovr from "@/views/DetailMooovr";
import DetailHairSchedule from "@/views/DetailHairSchedule";
import DetailExperienceElements from "@/views/DetailExperienceElements";
import DetailNineOClock from "@/views/DetailNineOClock";
import DetailNana from "@/views/DetailNana";
import DetailSaveEarth from "@/views/DetailSaveEarth";
import DetailDove from "@/views/DetailDove";
import DetailSuabow from "@/views/DetailSuabow";

/* new version */
import Rehabit from "@/views/portfolios/Rehabit";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // {
  //   path: "/detail/connect",
  //   name: "DetailConnect",
  //   component: DetailConnect,
  // },
  {
    path: "/detail/rehabit",
    name: "Rehabit",
    component: Rehabit,
  },
  {
    path: "/detail/telerehap",
    name: "DetailTelerehap",
    component: DetailTelerehap,
  },
  {
    path: "/detail/bium",
    name: "DetailBium",
    component: DetailBium,
  },
  {
    path: "/detail/taste-of-book",
    name: "DetailTasteOfBook",
    component: DetailTasteOfBook,
  },
  {
    path: "/detail/milk-ui",
    name: "DetailMilkUi",
    component: DetailMilkUi,
  },
  {
    path: "/detail/alice",
    name: "DetailAlice",
    component: DetailAlice,
  },
  {
    path: "/detail/mgtable",
    name: "DetailMgtable",
    component: DetailMgtable,
  },
  {
    path: "/detail/mooovr",
    name: "DetailMooovr",
    component: DetailMooovr,
  },
  {
    path: "/detail/hair-schedule",
    name: "DetailHairSchedule",
    component: DetailHairSchedule,
  },
  {
    path: "/detail/experience-elements",
    name: "DetailExperienceElements",
    component: DetailExperienceElements,
  },
  {
    path: "/detail/nine-o-clock",
    name: "DetailNineOClock",
    component: DetailNineOClock,
  },
  {
    path: "/detail/nana",
    name: "DetailNana",
    component: DetailNana,
  },
  {
    path: "/detail/save-earth",
    name: "DetailSaveEarth",
    component: DetailSaveEarth,
  },
  {
    path: "/detail/suabow",
    name: "DetailSuabow",
    component: DetailSuabow,
  },
  {
    path: "/detail/dove",
    name: "DetailDove",
    component: DetailDove,
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) return savedPosition;
  else return { left: 0, top: 0 };
};

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  scrollBehavior,
  routes,
});

export default router;
